export enum EWmsTags {
  BACKGROUND_WMS = 'backgroundWms'
}

export type TFetchBackgroundWmsParams = {
  district: string;
  portalId: number;
};
